import styled from "styled-components";

export const SearchGameItemBox = styled.div`
    width: calc(100% / 3);
    padding-right: 3px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
`;
